import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=7405b689&lang=html&"
import script from "./message-box.vue?vue&type=script&lang=js&"
export * from "./message-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7405b689')) {
      api.createRecord('7405b689', component.options)
    } else {
      api.reload('7405b689', component.options)
    }
    module.hot.accept("./message-box.vue?vue&type=template&id=7405b689&lang=html&", function () {
      api.rerender('7405b689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/message-box.vue"
export default component.exports